<template>
    <div >
        <section style="height: 100vh;overflow: hidden;">
            <div style="height: 100vh;position: relative;">
                <el-row class="page-top" type="flex" justify="center" align="center">
                        <el-col :md="6" align="center" style="position: relative;">
                            <el-col :md="24" style="position: absolute;opacity: .2;letter-spacing: 5px;font-weight: bold;">
                                <h1 >CONTACT US</h1>
                            </el-col>
                            <el-col :md="24">
                                <h1 style="color: #fff;font-weight: bold;">{{$t('join.ltitle')}}</h1>
                                <h6>CONTACT US</h6>
                                <h6>{{$t('join.linfo')}}</h6>
                            </el-col>
                        </el-col>
                </el-row>
                <el-row type="flex" justify="center">
                    <div class="more-page">
                        <p class="iconfont mh-weibiaoti-1-18"></p>
                        <p class="iconfont mh-weibiaoti-1-19 one"></p>
                        <p class="iconfont mh-weibiaoti-1-19 two"></p>
                    </div>
                </el-row>
            </div>
        </section>
        
        
        <el-row type="flex" justify="center" class="h-menu-panel" >
            <el-col :md="20" class="h-menu-title">
                <div class="news-sub">RECPJIT</div>
                <div class="news-title" >{{$t('join.title')}}</div>
            </el-col>
        </el-row>
        
        
        <el-row type="flex" justify="center" >
            <el-col :md="20" :sm="22">
                <el-col :md="6" :sm="24"  class="hidden-sm-and-down">
                    <h6>{{$t('join.ltitle')}}</h6>
                    <h3>{{$t('join.linfo')}}</h3>
                </el-col>
                <el-col :md="18"  :sm="24">
                    <el-row type="flex" justify="center">
                        <el-col :md="22" :sm="22" :xs="22" style="font-size: 16px;line-height: 28px;">
                            <el-col :md="24" >
                                <div style="text-indent: 32px;">{{$t('join.info')}}</div>
                            </el-col>
                            <el-col :md="22" style="margin-top: 20px;">
                                <p>{{$t('join.email.address')}}</p>
                                <p>{{$t('join.email.title')}}</p>
                            </el-col>
                        </el-col>
                        
                    </el-row>
                </el-col>
            </el-col>
        </el-row>
        
        <el-row type="flex" justify="center" class="nowjob">
            <el-col :md="20" :sm="20" :xs="22" style="display: flex;" class="hidden-sm-and-down">
                <div style="padding: 5px 15px 5px 0;" class="">{{$t('join.jobing')}}</div>
                <!-- <div @click="redirect(href)" class="more-jobs hover-hand">查看更多 +</div> -->
            </el-col>
            <el-col :md="20" :sm="20" :xs="22" style="display: flex;justify-content: center;margin-top: 20px;" class="hidden-md-and-up">
                <!-- <div @click="redirect(href)" class="more-jobs">查看更多 +</div> -->
            </el-col>
        </el-row>
        
        <el-row type="flex" justify="center" class="work-list">
            <el-col :md="20">
                <el-row type="flex" justify="center">
                    <el-col :md="24" :sm="22" :xs="22">
                        <el-col   :sm="22" :md="12" v-for="(item,index) in $t('join.jobs')" :key="index" style="padding: 0 10px"   
                                @mouseover.native="onHover(index)">
                             <div  class="jobs b-t-r">
                                 <el-col :md="24" class="job-content">
                                     <div class="job-title" ><p>{{item.title}}</p> <span>{{item.location}}</span></div>
                                     <div class="job-msg">{{item.content}}</div>
                                 </el-col>
                                 <!-- <el-col :md="3" :xs="3" :sm="3" class="job-more">
                                     <a :href="item.href"  target="_blank">
                                     <p class="iconfont mh-right" style="font-size: 40px;opacity: .5;"
                                        :style="{color:idx == index ? '#fff':'#000'}"
                                     ></p>
                                     </a>
                                 </el-col> -->
                             </div>
                         </el-col>
                    </el-col>
                </el-row>
            </el-col>
            
        </el-row>
    </div>
</template>

<script>
    export default{
        data() {
            return{
                idx:0,
                href:'https://www.zhipin.com/gongsi/7e5a8abf099628241n140ty5Fls~.html'
            }
        },
        methods:{
            onHover(idx){
                //console.log(idx)
                this.idx = idx
            },
            redirect(href){
                //window.open(href,'_blank')
            }
        }
    }
</script>

<style lang="scss">
    @import '../assets/mh.scss';
    .jactive{
        transform: scale(1.02) translateZ(0);
        box-shadow: 2px 2px 5px #e2e2e2;
        cursor: pointer;
    }
    .nowjob{
        @media only screen and (max-width:992px){
            margin-top: 30px;
        }
        margin-top: 80px;
    }
    .more-jobs{
        align-items: center;
        display: flex;
        padding: 0 15px; 
        font-size: 14px; 
        color: #BA4D48;
        border: 2px solid #BA4D48;
        @media only screen and (max-width:920px){
            margin-top: 20px;
           
            color: #BA4D48;
        }
        padding: 4px 15px;
        &:hover{
            background-color: #BA4D48;
            color: #ffffff;
        }
    }
    .iconfont{
        
    }
    .work-list{
        @media only screen and (max-width:992px){
            margin-top: 20px;
        }
        margin-top: 10px;
    }
    .jobs{
        
        transition: all .3s;
        
        box-shadow: 0px 0px 2px #949494;
        
        
        border-radius: 15px;
        display: flex;
        align-items: center;
        @media only screen and (max-width:992px){
            padding: 20px 10px 30px 10px;
            margin-top: 25px;
        }
        margin-top: 15px;
        padding: 30px 30px;
        .job-content{
            padding: 0 20px;
            .job-title{
                padding: 10px 0 5px;
                display: flex;
                justify-content: space-between;
                font-size: $h-news-title;
                font-weight: bold;
                border-bottom: 1px solid #bcbcbc;
            }
            .job-msg{
                opacity: .7;
                
                font-size: $h-font-16;
                padding: 10px 0;
                
                overflow: hidden;
                /* height: 49px; */
                display: -webkit-box;
                @media only screen and (max-width:992px){
                    -webkit-line-clamp: 3;
                    height: 80px;
                }
                height: 110px;
                -webkit-line-clamp: 4;
                -webkit-box-orient: vertical;
            }
        }
        .job-more{
            a{
                text-decoration: none;
            }
            display: flex;
            justify-content: center;
            align-items: center;
        }
        
    }
    P{
        margin: 0;
        padding: 0;
    }
    
    .page-top{
        height: 100vh;
        width: 100vw;
        position: relative;
        background-image: url('https://scan-code.oss-cn-hangzhou.aliyuncs.com/menhu/pgtp/join.jpg');
        background-position: center center;
        background-size: cover;
        align-items: center;
        .page-title{
            height: 100vh;
            align-items: center;
            display: flex;
            
        }
        h1{
            color: #fff;
            font-weight: bold;
        }
        h6{
            &+h6{
               border-top: 1px solid #acacac; 
               letter-spacing: 3px;
            }
            color: #fff;
            padding: 20px 0;
        }
    }
    .menu{
        letter-spacing: 3px;
        width: 100%;
        position: absolute;
        z-index: 99;
        bottom: 0;
        .item{
            transition: background .4s ease-in-out;
            padding: 15px 0;
            &+.item{
                border-left: 1px solid #acacac;
            }
        }
        .active{
            background-color: #BA4D48;
            color: #FFF;
        }
        .lose{
            background-color: #FFF;
            color: #000
        }
    }
    
    
</style>